













































import {
    computed,
    defineComponent,
    ref,
    reactive,
    toRefs,
} from '@vue/composition-api';
import { init as ssoSDKInit, getQRLoginInfo, getUserLoginInfo, scanQRAcceptResult, BaseRes, QRCodeResult } from '@ks/sso';
import { portalKPN, portalSid, envSSOSDK } from '@/common/consts';

const errorMessage = {
    timeout: '二维码已过期',
    error: '获取二维码失败',
    abandon: '二维码已过期',
};

function encodeData(data: Record<string, any>) {
    return Object.keys(data).reduce(
        (acc: Record<string, string>, current: string) => {
            acc[current] = encodeURIComponent(data[current]);
            return acc;
        },
        Object.create(null),
    );
}

export default defineComponent({
    name: 'ks-qr-code',
    props: {
        type: {
            type: String,
            required: true,
        },
        info: {
            type: Object,
            required: true,
        },
        size: {
            type: String,
            default: '140px',
        },
    },
    setup(props, context) {
        const data = reactive({
            loading: false,
            accept: false,
            errorStatus: '',
            qrCode: '',
            failMessage: '',
        });
        const qrCodeSize = ref(props.size);
        const inlineStyle = computed(
            () => `height: ${props.size};width: ${props.size}`,
        );
        const qrCodeUrl = computed(
            () => `data:image/PNG;base64,${data.qrCode}`,
        );
        const reset = () => {
            data.qrCode = '';
            data.errorStatus = '';
        };
        const setError = (type: string) => {
            data.errorStatus = type;
            data.accept = false;
            data.failMessage = Reflect.get(errorMessage, type);
        };
        const init = async () => {
            reset();
            try {
                data.loading = true;
                // 扫码功能调用前必须进行sso初始化，并传递相关参数

                ssoSDKInit({
                    sid: portalSid,
                    env: envSSOSDK,
                    qrType: props.type,
                    kpn: portalKPN,
                    serviceOwnParams: JSON.stringify(encodeData(props.info)),
                    // 为 true 的话，扫码授权就会调用 callback，用来登录，但是授权场景下，扫码不用做登陆
                    // 因此SDK新增了方法：scanQRAcceptResult
                    kuaishouAuth: false,
                    disableQuickLogin: true,
                    enableSig4: true,
                })

                // 第一步：获取二维码信息
                const { qrLoginSignature, qrLoginToken, imageData} = await getQRLoginInfo({
                    // 会覆盖 init 时初始化的 qrType
                    qrType: props.type,
                });

                data.loading = false;
                data.qrCode = imageData;

                // 第二步：等待用户扫码
                const userInfo = await getUserLoginInfo({qrLoginToken, qrLoginSignature}) as BaseRes & QRCodeResult;
                data.errorStatus = 'timeout';
                data.failMessage = '二维码已过期';

                // 第三步：用户扫码回调
                const token = await scanQRAcceptResult(
                    {
                        // 这块扫码有两套 新的扫码优先使用 scanResult 返回的签名
                        // 见下方文档中：扫码登录示例
                        // https://docs.corp.kuaishou.com/k/home/VHb3TfJ8laDI/fcAChnT6DXZ5m3xwQU1ouUAqA#section=h.6jwysngnj6fr
                        qrLoginSignature: userInfo.qrLoginSignature || qrLoginSignature,
                        qrLoginToken,
                    }
                )

                data.errorStatus = '';
                data.failMessage = '';
                data.accept = true;
                context.emit('accept', token.serviceOwnToken);
            } catch (e) {
                setError(e.message);
                if (e.message === 'abandon') {
                    context.emit('abandon');
                }
            }
        };
        init();
        return {
            init,
            qrCodeUrl,
            qrCodeSize,
            inlineStyle,
            ...toRefs(data),
            setError,
        };
    },
});
